// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/style.css'
import './assets/iconfont/iconfont.js'
import clipboard from 'clipboard'
import { Toast, Field, Loading, Overlay } from 'vant';
import store from './store'
import api from './api'
import common from './common'
import axios from 'axios'
import Floating from '@/components/common/floating.vue'
import Laod from '@/components/common/laoding.vue'
import Footer from '@/components/common/footer.vue'
import wxShare from '@/components/wxjsapi/share.vue'
import wxNoShare from '@/components/wxjsapi/noShare.vue'

Vue.prototype.$api = api
Vue.prototype.$axios = axios
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.prototype.clipboard = clipboard

Vue.use(Toast)
Vue.use(Field)
Vue.use(Overlay)
Vue.use(Loading)

// 全局自定义组件
Vue.component("Floating", Floating)
Vue.component("Laod", Laod)
Vue.component("Footer", Footer)
Vue.component("wxShare", wxShare)
Vue.component("wxNoShare", wxNoShare)

// 使用router.beforeEach注册一个全局前置守卫,判断用户是否登录
router.beforeEach((to, from, next) => {
  // 修改 title 值
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const isLogin = store.state.auth ? store.state.auth : window.localStorage.getItem('auth')
  let redirectUri = window.location.href
  let code = getUrlParam("code")

  //这里的requireAuth为路由中定义的 meta:{requireAuth:true}，意思为：该路由添加该字段，表示进入该路由需要登陆的
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (isLogin) {
      next();
    } else {
      /*
      if(process.env.NODE_ENV === 'production') {
        // 微信授权登录
        if(!code){
          sessionStorage.setItem('redirectPath', redirectUri)
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + process.env.WX_APPID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
        }
        axios.post(process.env.API_URL + '/fw/socials/wechat/authorizations?code=' + code).then(function (res) {
          let data = res.data
          if (data.success === 1) {
            window.localStorage.setItem('weixin_openid', data.data.oauth_user.weixin_openid)
            window.localStorage.setItem('auth', true)
            store.dispatch('logined', data.data.access_token)
            // 判断分享的重定向页面
            let redirectPath = sessionStorage.getItem('redirectPath')
            if (redirectPath) {
              sessionStorage.removeItem('redirectPath')
              window.location.href = redirectPath
            } else {
              next()
            }
          } else {
            // 未获得信息 手机号登录
            next({
              path: '/login',
              query: {redirect: to.fullPath}
            })
          }
        })
      }else{
        next({
          path: '/login',
          query: {redirect: to.fullPath}
        })
      }
      */
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next();
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    /*
    // 自定义的 axios 响应拦截器
    this.$axios.interceptors.response.use((response) => {
      // 判断一下响应中是否有 token，如果有就直接使用此 token 替换掉本地的 token。你可以根据你的业务需求自己编写更新 token 的逻辑
      var token = response.headers.authorization
      if (token) {
        // 如果 header 中存在 token，那么触发 refreshToken 方法，替换本地的 token
        this.$store.dispatch('refreshToken', token)
      }
      return response
    }, (error) => {
      switch (error.response.status) {
        // 如果响应中的 http code 为 401，那么则此用户可能 token 失效了之类的，我会触发 logout 方法，清除本地的数据并将用户重定向至登录页面
        case 401:
          this.$store.dispatch('logout')
          return
          //return this.$toast(error.response.data.message)
          break
        // 如果响应中的 http code 为 400，那么就弹出一条错误提示给用户
        case 400:
          return this.$toast(error.response.data.error)
          //return this.$Message.error(error.response.data.error)
          break
      }
      return Promise.reject(error)
    })
    */
  }
})

// 解析url参数并获取code
function getUrlParam(name) {
  //name为要获取的参数名
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var rrr = decodeURIComponent(window.location.search);
  var r = rrr.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}





// WEBPACK FOOTER //
// ./src/main.js